import React, { useEffect } from 'react';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { useDispatch, useSelector } from 'react-redux';
import { getManageAppraisalData } from '../../../../../redux/features/appraisalSlice';
import ManageAppraisalCard from './ManageAppraisalCard';

const ManageAppraisal = ({ open, setOpen, id,cycleName }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      dispatch(getManageAppraisalData(id));
    }
  }, [open]);
  return (
    <GlobalDialog
      title={'Manage Appraisal'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullScreen
      content={
        <>
          <ManageAppraisalCard open={open} cycleName={cycleName} cycleId={id} />
        </>
      }
    />
  );
};

export default ManageAppraisal;
